import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-role-color-picker',
  template: `
    <h2 mat-dialog-title>Choose color for {{data.role}}</h2>
    <mat-dialog-content>
      <div class="color-picker-container">
        <input 
          type="color" 
          [value]="data.currentColor"
          (input)="selectedColor = $event.target.value"
        >
      </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button (click)="onNoClick()">Cancel</button>
      <button mat-button [mat-dialog-close]="selectedColor" color="primary">Save</button>
    </mat-dialog-actions>
  `,
  styles: [`
    .color-picker-container {
      padding: 20px;
      display: flex;
      justify-content: center;
    }
    input[type="color"] {
      width: 100px;
      height: 100px;
      padding: 0;
      border: none;
      border-radius: 50%;
      overflow: hidden;
    }
  `]
})
export class RoleColorPickerComponent {
  selectedColor: string;

  constructor(
    public dialogRef: MatDialogRef<RoleColorPickerComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {role: string; currentColor: string}
  ) {
    this.selectedColor = data.currentColor;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}